export const SHOW_RUTA_MODAL = "SHOW_RUTA_MODAL";
export const HIDEN_RUTA_MODAL = "HIDEN_RUTA_MODAL";
export const SELECTED_RUTA = "SELECTED_RUTA";
